module.exports = __webpack_public_path__ + "static/img/Lachie-Jaques.37e450d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie-Jaques.jpg
// module id = FRaN
// module chunks = 0